/**
 * Minimum and maximum age (in weeks) for subscribing a pet.
 */
export const MIN_AGE_WEEKS = 8;
export const MAX_AGE_WEEKS = 30 * 52;
